import { render, staticRenderFns } from "./renovacionPortalComercial.vue?vue&type=template&id=628f02f8"
import script from "./renovacionPortalComercial.vue?vue&type=script&lang=js"
export * from "./renovacionPortalComercial.vue?vue&type=script&lang=js"
import style0 from "./renovacionPortalComercial.vue?vue&type=style&index=0&id=628f02f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports